var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_2110a62a"]},_vm.$listeners),[_c('cube-button',{attrs:{"primary":"","active":""}},[_vm._v("激活态")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }